import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

async function getConversationUrn(
  workspaceId: string,
  accountId: string,
  leadId: string,
) {
  const { conversation_urn: conversationUrn } = await get(
    `workspaces/${workspaceId}/accounts/${accountId}/leads/${leadId}/conversation-urn`,
  );
  return conversationUrn;
}

export default function useLeadConversationUrn(
  params:
    | {
        leadId: string;
        accountId: string;
      }
    | undefined,
) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { leadsKeys } = getQueryKeys(workspaceId);

  const { data: leadConversationUrn } = useQuery<string>({
    queryKey: params ? leadsKeys.conversationUrn(params.leadId) : undefined,
    queryFn: params
      ? () => getConversationUrn(workspaceId, params.accountId, params.leadId)
      : undefined,
  });
  return leadConversationUrn;
}
